import {PrivateCommand} from "../PrivateCommand";
import cmp from "../../../context/context";
import {log} from "../../../util/log";

export class NeedAcquireConsentPrivateCommand extends PrivateCommand {

    public execute(option?: string, callback?: Function): void {
        const need: boolean = !cmp().consentAcquired;
        if (callback) {
            if (need) log.debug('Need to acquire consent');
            else log.debug('Consent already acquired');
            callback(need);
        }
    }
}
